import { useLanguage } from '../contexts/LanguageContext';
import { ServicesGallery, Gallery4Props } from "./ServicesGallery"
    
export default function ServicesSection() {
    const { t } = useLanguage();
    const demoData: Gallery4Props = {
        title: t('home.services.title'),
        description:
          t('home.services.description'),
        items: [
          {
            id: "0",
            title: t('home.services.cards.card0.title'),
            description:
              t('home.services.cards.card0.description'),
            href: "/services#managementConsultingService",
            image:
              "/images/services-0.jpg",
          },
          {
            id: "1",
            title: t('home.services.cards.card1.title'),
            description:
              t('home.services.cards.card1.description'),
            href: "/services#structureService",
            image:
              "/images/services-1.jpg",
          },
          {
            id: "2",
            title: t('home.services.cards.card2.title'),
            description:
              t('home.services.cards.card2.description'),
            href: "/services#foreignBusinessService",
            image:
              "/images/services-2.jpg",
          },
          {
            id: "3",
            title: t('home.services.cards.card3.title'),
            description:
              t('home.services.cards.card3.description'),
            href: "/services#govServices",
            image:
              "/images/services-3.jpg",
          },
          {
            id: "4",
            title: t('home.services.cards.card4.title'),
            description:
              t('home.services.cards.card4.description'),
            href: "/services#hrService",
            image:
              "/images/services-4.jpg",
          },
          {
            id: "5",
            title: t('home.services.cards.card5.title'),
            description:
              t('home.services.cards.card5.description'),
            href: "/services#accountingService",
            image:
              "/images/services-5.jpg",
          },
          {
            id: "6",
            title: t('home.services.cards.card6.title'),
            description:
              t('home.services.cards.card6.description'),
            href: "/services#technologyService",
            image:
              "/images/services-6.jpg",
          },
          {
            id: "7",
            title: t('home.services.cards.card7.title'),
            description:
              t('home.services.cards.card7.description'),
            href: "/services#marketingService",
            image:
              "/images/services-7.jpg",
          },
          {
            id: "8",
            title: t('home.services.cards.card8.title'),
            description:
              t('home.services.cards.card8.description'),
            href: "/services#legalService",
            image:
              "/images/services-8.jpg",
          },
        ],
      };
      
      
    return (
        <section className='relative py-[6rem] bg-transparent overflow-hidden'>
            <div className="absolute top-[22px] -left-[15px] sm:-left-[40px] md:-left-[80px] md:h-[200px] h-[60px] sm:h-[100px] rotate-[79deg] hidden sm:block" >
                <img src='/images/corner-decorations.png' alt='' className='w-full h-full' />
            </div> 
            <div className="absolute bottom-[0] right-[-15px] sm:right-[-40px] md:right-[-80px] md:h-[180px] h-[60px] sm:h-[100px] rotate-[-100deg] hidden sm:block" >
                <img src='/images/corner-decorations.png' alt='' className='w-full h-full' />
            </div>
            <ServicesGallery items={demoData.items} title={t('home.services.title')} description={t('home.services.description')} />
        </section>
    )
}